const DocumentsEndpoints = {
  index: "documents/",
  /** POST { upload_id | file_string, file_name, original_name, name?, folder_path? } */
  new: "documents/",
  /**
   * Chunked upload for big files (see common/api/chunkedUpload.js): POST
   * multipart pieces to `chunk`, then send `upload_id` to any document
   * endpoint instead of `file_string`.
   */
  upload: {
    /** GET: { max_chunk_bytes, max_total_bytes } */
    limits: "documents/upload/limits",
    /** POST multipart { upload_id, chunk_index, chunk_count, chunk } */
    chunk: "documents/upload/chunk",
    /** DELETE + uploadId: drop the pieces */
    discard: "documents/upload/",
  },
  delete: "documents/delete/",
  show: "documents/preview/",
  showPostFiles: "document/post/show/",
  addToPost: "document/post/new/",
  removeFileFromPost: "document/post/delete/",
  connectFileToPost: "document/post/connect/",
  sort: "document/post/sort",
  imagePosts: "document/post/image/",
  /** title overlay of one image *in one post* — never touches the stored file */
  overlay: "document/post/overlay",
  /** the image with the title burned in, rendered on the fly, never stored */
  overlayRender: "document/post/overlay/render/",
  /** file-manager folders: GET list / POST {path} create */
  folders: "documents/folders/",
  /** PUT {from, to} — moves files and sub-folders along */
  folderRename: "documents/folders/rename",
  /** DELETE, path as query string; 409 while files are inside */
  folderDelete: "documents/folders/?path=",
  /** PUT {path} on one file; empty path = root */
  moveToFolder: "documents/folder/",
};

export default DocumentsEndpoints;
